import { Box, Button, Divider, Grid, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import Modal from "react-modal";
import Icon from "../../atoms/icon/Icon";

// Helper function to format date from YYYY-MM-DD to MM-DD-YYYY
function formatDateMMDDYYYY(dateStr) {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${month}-${day}-${year}`;
}

const ViewInsurance = ({ isOpen, onClose, insuranceDetails }) => {

    // Styling for the text field label
  const styleText = {
    color: '#2C251E',
    fontWeight: '600',
    fontSize: '14px',
    padding: '5px 0',
    alignContent: "center"
  };

  const styleInsuranceLabel = {
    color: '#2C251E',
    fontWeight: '300',
    fontSize: '14px',
    padding: '5px 0',
    opacity: '0.6',
  };

  const styleInsuranceText = {
    color: '#2C251E',
    fontWeight: '300',
    fontSize: '14px',
    padding: '5px 0',
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Insurance Details Modal"
      style={{
        overlay: {  zIndex: 9999, backgroundColor: "rgba(0, 0, 0, 0.5)" },
                        content: {
                          // inset: "unset",
                          border: "none",
                          borderRadius: "16px",
                          background: "#FEFEFE",
                          padding: "24px",
                          width: "75%",
                          // display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
                          // Responsive adjustments
                          transition: "all 0.3s ease",
                          top: "50%",
                          left: "50%",
                          right: "auto",
                          bottom: "auto",
                          marginRight: "-50%",
                          transform: "translate(-50%, -50%)",
                          maxWidth: "600px",
                          minWidth: "180px",
                          maxHeight: "80vh",
                        },
      }}
    >
      
        {insuranceDetails ? (
          <div>
            {/* Close Button */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
                position: "sticky"
              }}>

              <Button
                disableRipple
                onClick={onClose}
                sx={{
                  background: "none",
                  color: "#2C251E",
                  border: "1px solid #2C251E",
                  padding: "7px",
                  borderRadius: "50px",
                  cursor: "pointer",
                  minWidth: "40px",
                  minHeight: "40px",
                  ":hover": {
                    background: "rgba(0, 0, 0, 0.1)"
                  }
                }}>

                  <Icon
                    src={require("../../../../assets/icons/close.png")}
                    size="small"/>

              </Button>

            </Box>

            {/* Title */}
            <Typography
              gutterBottom
              variant="h3"
              component="div"
              sx={{
                fontWeight: "600",
                padding: "10px 10px",
                fontSize: "24px",
                // backgroundColor: "aqua",
                marginBottom: "0px",
                textAlign: "center",
              }}>Insurance Details
            </Typography>

            {/* Detail Container */}
            <Box
              textAlign="start"
              sx={{
                margin: "20px 0 50px 0",
              }}>


                {/*Grids */}
                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={2}
                  sx={{
                    // backgroundColor: "blue",
                    "& .MuiGrid-item": {
                      display: "flex",
                      justifyContent: "center",
                      // backgroundColor: "blue",
                    },
                  }}>

                        {/* Insurance Details */}
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} item>

                              {/*Grid */}
                              <Grid
                                container
                                columnSpacing={2}
                                sx={{
                                  border: '2px solid rgba(197, 165, 114, 0.4)',
                                      borderRadius: '10px',
                                      padding: '12px',
                                  // backgroundColor: "blue",
                                  "& .MuiGrid-item": {
                                    display: "flex",
                                    justifyContent: "center",
                                    // backgroundColor: "blue",
                                  },
                                }}>

                                {/* Label Name */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceLabel}>
                                    Name
                                  </Typography>
                                      
                                </Grid>

                                {/* Input Name */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceText}>
                                    {insuranceDetails.name}
                                  </Typography>
                                      
                                </Grid>

                                {/* Label Company Name */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item sx={{ pt: {xs:"10px"}}}>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceLabel}>
                                    Company Name
                                  </Typography>
                                      
                                </Grid>

                                {/* Input Company Name */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceText}>
                                    {insuranceDetails.companyName}
                                  </Typography>
                                      
                                </Grid>

                                {/* Label Mobile Number */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item sx={{ pt: {xs:"10px"}}}>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceLabel}>
                                    Mobile Number
                                  </Typography>
                                      
                                </Grid>

                                {/* Input Mobile Number */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceText}>
                                    {insuranceDetails.contactNumber}
                                  </Typography>
                                      
                                </Grid>

                                {/* Label HMO Card */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item sx={{ pt: {xs:"10px"}}}>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceLabel}>
                                    HMO Card
                                  </Typography>
                                      
                                </Grid>

                                {/* Input HMO Card*/}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceText}>
                                    {insuranceDetails.hmoCard}
                                  </Typography>
                                      
                                </Grid>

                                {/* Label HMO Account Number */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item sx={{ pt: {xs:"10px"}}}>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceLabel}>
                                    HMO Account Number
                                  </Typography>
                                      
                                </Grid>

                                {/* Input HMO Account Number */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceText}>
                                    {insuranceDetails.hmoAccountNumber}
                                  </Typography>
                                      
                                </Grid>

                                {/* Label Valid Government ID */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item sx={{ pt: {xs:"10px"}}}>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceLabel}>
                                    Valid Government ID
                                  </Typography>
                                      
                                </Grid>

                                {/* Input Valid Government ID */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceText}>
                                    {insuranceDetails.validGovernmentID}
                                  </Typography>
                                      
                                </Grid>

                                {/* Label Valid Government ID Number */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item sx={{ pt: {xs:"10px"}}}>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceLabel}>
                                    Valid Government ID Number
                                  </Typography>
                                      
                                </Grid>

                                {/* Input Valid Government ID Number */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceText}>
                                    {insuranceDetails.validGovernmentIDNumber}
                                  </Typography>
                                      
                                </Grid>

                                {/* Label Birthdate */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item sx={{ pt: {xs:"10px"}}}>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceLabel}>
                                    Birthdate
                                  </Typography>
                                      
                                </Grid>

                                {/* Input Birthdate*/}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceText}>
                                    {formatDateMMDDYYYY(insuranceDetails.birthdate)}
                                  </Typography>
                                      
                                </Grid>

                                {/* Label Relationship */}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item sx={{ pt: {xs:"10px"}}}>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceLabel}>
                                    Relationship
                                  </Typography>
                                      
                                </Grid>

                                {/* Input Relationship*/}
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} item>

                                  {/* Text */}
                                  <Typography variant="h3" sx={styleInsuranceText}>
                                    {insuranceDetails.relationship}
                                  </Typography>
                                      
                                </Grid>

                              </Grid>
                            

                        </Grid>

                </Grid>
                        

            </Box>
          </div>
        ) : (
          <div>
                              <i>
                              <TextField
                                // error={Boolean(inputError)}
                                // id={id}
                                // type={type}
                                value="No Insurance Provided"
                                variant="outlined"
                                // required
                                // helperText={errorText}
                                // color={color}
                                FormHelperTextProps={{
                                  sx: { color: 'error.main' }
                                }}
                                InputProps={{
                                  readOnly: true,
                                  sx: {
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      borderColor: 'rgba(197, 165, 114, 0.4)',
                                      borderWidth: '2px',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                      borderColor: 'rgba(197, 165, 114, 0.4)',
                                    },
                                  },
                                }}
                                // onChange={handleChange}
                                sx={{
                                  width: '100%',
                                  borderRadius: '10px',
                                }}>
                              </TextField>
                              </i>

                            </div>
        )}
      
    </Modal>
  );
};

export default ViewInsurance;